// The two facts the review surfaces derive from a finding's own columns.
import { BEHAVIOUR_SEVERITIES } from "./traceEvaluation.js";

// Content sensitivity mapped onto the behaviour ladder, so a finding with two
// severity axes has one comparable severity.
const CONTENT_TO_BEHAVIOUR = Object.freeze({
    none: "none",
    internal: "low",
    confidential: "medium",
    restricted: "high",
});

function rank(ladder, value) {
    return ladder.indexOf(String(value ?? "").toLowerCase());
}

// The higher of behaviour severity and mapped content sensitivity.
export function effectiveSeverity(f) {
    const b = String(f?.behaviourSeverity ?? "none").toLowerCase();
    const c = CONTENT_TO_BEHAVIOUR[String(f?.contentSensitivity ?? "none").toLowerCase()] ?? "none";
    return rank(BEHAVIOUR_SEVERITIES, b) >= rank(BEHAVIOUR_SEVERITIES, c) ? b : c;
}

// A claim result the projection left empty is "no verdict". It is never
// refuted: a verifier outage must read as unverified, not as a drop in flagged
// volume.
export function normalizeClaim(v) {
    const s = String(v ?? "").toLowerCase();
    if (!s || s === "unspecified" || s === "indeterminate") return "unverified";
    return s;
}
